export default "/images/20 Step5KeepItUp-Consultant-To monitor progress.png?06694bed134fe9794256f26c03418155";